import { render, staticRenderFns } from "./directPayComponentMapping.vue?vue&type=template&id=fd895c6c"
import script from "./directPayComponentMapping.vue?vue&type=script&lang=js"
export * from "./directPayComponentMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports